import React from "react";
import { Button } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

function NotFound() {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white pt-20 pb-20 mt-40">
            <div className="flex items-center justify-center gap-4">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="mt-5 w-28 h-28 text-cyan-500 animate-bounce"
                >
                    <path d="M12 2a10 10 0 100 20 10 10 0 000-20zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                </svg>
                <h1 className="text-9xl font-extrabold text-cyan-400 drop-shadow-lg">
                    404
                </h1>
            </div>
            <div className="max-w-lg text-center mt-4">
                <h2 className="text-2xl md:text-3xl font-bold font-syne">
                    Oops! Page Not Found
                </h2>
                <p className="mt-3 text-gray-400 font-outfit">
                    The page you’re looking for doesn’t exist or has been moved.
                    Don’t worry, you can head back to the homepage.
                </p>
                <div className="mt-6">
                    <Button
                        type="primary"
                        icon={<HomeOutlined />}
                        size="large"
                        className="!bg-cyan-500 hover:!bg-cyan-400 !border-none !rounded-full font-syne shadow-lg"
                        onClick={() => navigate("/")}
                    >
                        Back to Home
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default NotFound;
